import { createContext, useContext } from "react";

export interface AutosaveContextType {
  isAutosaving: boolean;
  setIsAutosaving: (value: boolean) => void;
  triggerAutosave: () => void;
}

export const AutosaveContext = createContext<AutosaveContextType | null>(null);

const NOOP_AUTOSAVE_CONTEXT: AutosaveContextType = {
  isAutosaving: false,
  setIsAutosaving: () => {
    // no-op: used by editors that don't support autosave
  },
  triggerAutosave: () => {
    // no-op: used by editors that don't support autosave
  },
};

export const useOptionalAutosaveContext = (): AutosaveContextType => {
  return useContext(AutosaveContext) ?? NOOP_AUTOSAVE_CONTEXT;
};

export const useAutosaveContext = () => {
  const context = useContext(AutosaveContext);
  if (!context) {
    throw new Error("useAutosaveContext must be used within RawEditor");
  }
  return context;
};
